$(document).ready(function(){
  setTimeout(function() {
 
    if($('.product-wrap p.product-thumbnail__title').length > 0){
      $('.product-wrap p.product-thumbnail__title').matchHeight();
    }
    if($('.product-wrap p.type-product').length > 0){
      $('.product-wrap p.type-product').matchHeight();
    }
  }, 5000);
  $('.custom-filter .selection').click(function () {
    let filter = $(this).closest('.custom-filter');
    if (filter.hasClass('open')) {
      filter.removeClass('open');
    } else {
      $('.custom-filter').removeClass('open');
      filter.addClass('open');
    }
    return false;
  });
  
  const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }
  window.addEventListener('resize', appHeight)
  appHeight()
});
